import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconRelatedContent$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRelatedContent extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4b0e947af791c6e1323992043b356488f6ff4ddc', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6203bd4181cb3ddb70e5ff571e0e2b8cdedb9063', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a553e5e87d025bc7fe778f59a3697e2348ea7cc2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.786 4.25a.29.29 0 0 0-.286.29v12.917c0 .16.128.29.286.29h9.679c.157 0 .285-.13.285-.29V14.25a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v2H4V5.775h5.25V7.31a.5.5 0 0 0 .5.5h1.5v.941a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V7.505a.5.5 0 0 0-.143-.35l-2.71-2.756a.5.5 0 0 0-.356-.149zM14.5 17.24a.5.5 0 0 0 .5.5h4.214c.158 0 .286-.13.286-.29V7.505a.5.5 0 0 0-.143-.35l-2.71-2.756a.5.5 0 0 0-.356-.149H13.5a.5.5 0 0 0-.5.5v.525a.5.5 0 0 0 .5.5H16V7.31a.5.5 0 0 0 .5.5H18v8.441h-3a.5.5 0 0 0-.5.5zM7.25 11a.25.25 0 0 1 .25-.25h8a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-8a.25.25 0 0 1-.25-.25z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-related-content", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-related-content"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-related-content":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRelatedContent$1);
            }
            break;
    } });
}

const CosmosIconRelatedContent = CosmosIconRelatedContent$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRelatedContent, defineCustomElement };
